import EventCardFooter from './event-card-footer/event-card-footer';
import EventDetailAction from './event-detail-action/event-deatil-action';
import EventSelectCity from './event-select-city/event-select-city';

Vue.component(EventCardFooter.name, EventCardFooter);
Vue.component(EventDetailAction.name, EventDetailAction);
Vue.component(EventSelectCity.name, EventSelectCity);
